export const AFFIX_OFFSET = 85;
